// @flow
import React, { useState } from 'react';

import InlineEditor, { type Props as InlineEditorProps } from './InlineEditor';

type Props = {
  ...$Rest<
    InlineEditorProps,
    {| onChange: (value: string, name: string) => void |}
  >,
};

const InlineEditorStateful = (props: Props) => {
  const [value, setValue] = useState(props.value);

  const onClose = (val, name, didConfirm) => {
    setValue(val);
    if (props.onClose) {
      props.onClose(val, name, didConfirm);
    }
  };

  return (
    <InlineEditor
      {...props}
      onChange={val => setValue(val)}
      onClose={onClose}
      value={value}
    />
  );
};

export default InlineEditorStateful;
